import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";

// Download user verification data
export const downloadUserVerificationData = createAsyncThunk(
  "verification/downloadUserVerificationData",
  async (userId, { rejectWithValue }) => {
    try {
      console.log("Downloading verification data for user:", userId);
      
      const response = await Api.get(`/user/${userId}/verification/download`, {
        responseType: 'blob' // Important for file download
      });
      
      // Create blob and download file
      const blob = new Blob([response.data], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename with current date
      const currentDate = new Date().toISOString().split('T')[0];
      link.download = `verification_data_${userId}_${currentDate}.json`;
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return {
        success: true,
        message: 'Verification data downloaded successfully',
        userId: userId,
        downloadedAt: new Date().toISOString()
      };
    } catch (error) {
      console.error("Download verification data error:", error);
      
      let errorMessage = 'Failed to download verification data';
      
      if (error.response?.status === 404) {
        errorMessage = 'No approved verification data found for this user';
      } else if (error.response?.status === 401) {
        errorMessage = 'Unauthorized access';
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      
      return rejectWithValue({
        message: errorMessage,
        status: error.response?.status || 500
      });
    }
  }
);

// Get user verification details (for displaying verification status)
export const getUserVerificationDetails = createAsyncThunk(
  "verification/getUserVerificationDetails",
  async (userId, { rejectWithValue }) => {
    try {
      console.log("Getting verification details for user:", userId);
      
      const response = await Api.get(`/user/${userId}/verification`);
      
      return response.data;
    } catch (error) {
      console.error("Get verification details error:", error);
      
      let errorMessage = 'Failed to get verification details';
      
      if (error.response?.status === 404) {
        errorMessage = 'User not found';
      } else if (error.response?.status === 401) {
        errorMessage = 'Unauthorized access';
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      
      return rejectWithValue({
        message: errorMessage,
        status: error.response?.status || 500
      });
    }
  }
);